/**
 * API submission logic
 */

import { formatBirthday } from '../utils/dateHelpers.js';
import { t } from '../../i18n.js';

export async function submitSignup(state) {
    const birthday = formatBirthday(state.day, state.month, state.year);

    // Get fresh reCAPTCHA token (v3 tokens expire after 2 minutes)
    let recaptchaToken = await getRecaptchaToken();

    const signupData = {
        name: state.name,
        email: state.email,
        birthday: birthday,
        sex: state.sex,
        username: state.username,
        password: state.password,
        city_id: state.cityId,
        home_city_id: state.homeCityId,
        lang: window.__i18nConfig?.locale || 'en_US'
    };

    // Add reCAPTCHA token if available
    if (recaptchaToken) {
        signupData.googleResponse = recaptchaToken;
    }

    try {
        const result = await window.ApiClient.createAccount(signupData);

        // Store token if returned
        if (result.token) {
            storeAuthToken(result.token);
        }

        return { success: true, result };

    } catch (error) {
        console.error('[Signup] API error:', error);

        if (error.validationErrors) {
            return {
                success: false,
                validationErrors: error.validationErrors
            };
        }

        return {
            success: false,
            error: error.message || t('auth.error_something_wrong')
        };
    }
}

async function getRecaptchaToken() {
    if (typeof grecaptcha === 'undefined' || !grecaptcha.execute) {
        return document.getElementById('googleResponse')?.value;
    }

    try {
        const siteKey = document.querySelector('[data-recaptcha-sitekey]')?.getAttribute('data-recaptcha-sitekey');

        if (siteKey) {
            const token = await grecaptcha.execute(siteKey, { action: 'signup' });
            return token;
        } else {
            console.warn('[Signup] No reCAPTCHA site key found');
            return document.getElementById('googleResponse')?.value;
        }
    } catch (e) {
        console.warn('[Signup] reCAPTCHA execution failed:', e);
        return document.getElementById('googleResponse')?.value;
    }
}

function storeAuthToken(token) {
    try {
        const existingState = localStorage.getItem('redux-state') || '{}';
        const state = JSON.parse(existingState);
        state.auth = state.auth || {};
        state.auth.token = token;
        localStorage.setItem('redux-state', JSON.stringify(state));
    } catch (e) {
        console.warn('[Signup] Could not store auth token:', e);
    }
}

export function getFieldStepMap() {
    return {
        'email': 1,
        'name': 2,
        'birthday': 3,
        'sex': 4,
        'city_id': 5,
        'home_city_id': 6,
        'password': 7,
        'username': 8
    };
}
